
export const DB_KEYS = {
    WAYBILLS: 'waybills',
    VEHICLES: 'vehicles',
    EMPLOYEES: 'employees',
    ORGANIZATIONS: 'organizations',
    FUEL_TYPES: 'fuelTypes',
    SAVED_ROUTES: 'savedRoutes',
    USERS: 'users',
    DB_SEEDED_FLAG: 'db_clean_seeded_flag_v6',
    SEASON_SETTINGS: 'seasonSettings',
    PRINT_POSITIONS: 'printPositions_v4_layout',
    PRINT_EDITOR_PREFS: 'printEditorPrefs_v1',
    APP_SETTINGS: 'appSettings_v1',
    GARAGE_STOCK_ITEMS: 'garageStockItems_v1',
    STOCK_TRANSACTIONS: 'stockTransactions_v1',
    WAYBILL_BLANK_BATCHES: 'waybillBlankBatches_v1',
    WAYBILL_BLANKS: 'waybillBlanks_v1',
    BUSINESS_AUDIT: 'businessAudit_v1',
    ROLE_POLICIES: 'rolePolicies_v1',
    STORAGES: 'storages_v1',
    TIRES: 'tires_v1',
    FUEL_CARD_SCHEDULES: 'fuelCardSchedules_v1',
    CALENDAR_EVENTS: 'calendarEvents_v1',
    COUNTERS: 'counters_v1', // Global counters for document numbering
    BALANCE_SNAPSHOTS: 'balanceSnapshots_v1',
    PERIOD_LOCKS: 'periodLocks_v1',
    REFUELINGS: 'refuelings_v1',
};
